import React from 'react';
import CustomBadge from '@/components/CustomBadge';

const FilterBadges = ({ filter, setFilter, setFilterForm }) => {
  const hasAppliedFilters = () => {
    return (
      filter.appliedFilters &&
      Object.entries(filter.appliedFilters).filter(
        ([key, value]) => value && key !== 'search'
      ).length > 0
    );
  };

  const getFilterLabel = (key, value) => {
    if (key === 'status') {
      const statusMap = {
        1: 'Registered',
        2: 'Active',
        3: 'Deactive',
        0: 'Suspended',
      };
      return statusMap[value] || value;
    }
    return value;
  };

  if (!hasAppliedFilters()) return null;

  return (
    <div className="relative z-99 w-full bg-white rounded-lg items-center flex flex-wrap gap-2 mb-4 py-3">
      <span className="text-sm">Filtered by:</span>
      {Object.entries(filter.appliedFilters)
        .filter(([key, value]) => value && key !== 'search')
        .map(([key, value]) => {
          return (
            <CustomBadge
              key={key}
              text={`${key.replace('_', ' ')}: ${getFilterLabel(key, value)}`}
              onClick={() => {
                const newFilters = { ...filter.appliedFilters };
                delete newFilters[key];

                setFilter({
                  ...filter,
                  appliedFilters: newFilters,
                });
                // Update form to reflect filter removal
                if (setFilterForm) {
                  const updatedForm = { ...filter.appliedFilters };
                  delete updatedForm[key];
                  setFilterForm(updatedForm);
                }
              }}
            />
          );
        })}
    </div>
  );
};

export default FilterBadges;
